// @ts-nocheck
import { Helmet } from 'react-helmet-async';

// CSSの読み込み
import "../../css/style.min.css";
import "../../css/App.css";

function maintenance() {
  return (
    <>
      <Helmet>
        <title>Z-link ログイン（メンテナンス）</title>
      </Helmet>
      <div className="theme-login">
        <div className="login-alert">
          <div className="login-alert-text">
            <p>※Googleにログインしていないと、<br />Z-linkのログイン画面（ポップアップ）は表示されません<br />ログイン後にリロードしてください</p>
          </div>
        </div>
        <div className="contents">
          <div className="login-wrap">
            <div className="login-wrap-main">
              <div className="login-wrap-left">
                <p>Zenkenで働くみんなのよりどころ</p>
                <img
                  src={process.env.PUBLIC_URL + '/logo_positive.svg'}
                  alt="Z-LINK"
                  className="Z-LINK"
                />
                <div className="login-btn">
                  <h2>現在メンテナンス中です。</h2>
                </div>
              </div>
              <div className="corporate-wrap">
                <img
                  className=""
                  src={process.env.PUBLIC_URL + '/year_anniversary_logo.png'}
                />
                <div className="purpose-area">
                  <div className="purpose-text">PURPOSE</div>
                  <span>そこにない未来を創る</span>
                  <div className="purpose-link">
                    <a href="https://www.zenken.co.jp/our-goal/purpose/" target="_blank">詳しく見る</a>
                  </div>
                </div>
                <div className="vision-area">
                  <div className="vision-text">VISION</div>
                  <span>持続可能な社会の創出</span>
                  <div className="vision-link">
                    <a href="https://www.zenken.co.jp/our-goal/vision/" target="_blank">詳しく見る</a>
                  </div>
                </div>
              </div>
            </div>
            <div className="login-help">
              <p className="login-help-main"><a href="https://docs.google.com/presentation/d/13tvJygOoIg_3r_30HF557KZf-JKA5EK0G8y0UPJWmhs/edit?slide=id.g35dc981076c_0_37#slide=id.g35dc981076c_0_37" className="text-link" target="_blank">ログイン方法はこちら</a></p>
              <p className="login-help-sub"><a href="https://docs.google.com/forms/d/e/1FAIpQLSf8J_qCvwGH2VtHBYTznvpzj_gLlwUg1BT5WVAFmrymr69ovQ/viewform" className="text-link sub" target="_blank">ログインできない場合のお問い合わせ</a></p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default maintenance;
